const getters = {
	sidebar: state => state.app.sidebar,
	visitedViews: state => state.tagsView.visitedViews,
	cachedViews: state => state.tagsView.cachedViews,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	name: state => state.user.name,
	roles: state => state.user.roles,
	language: state => state.app.language,
	permission_routers: state => state.permission.routerList,
	addRouters: state => state.permission.addRouters,
	asyncRouters: state => state.permission.asyncRouters,
	customerId: state => state.customer.customerId,
	customerName: state => state.customer.customerName,
	userId: state => state.user.userInfo.id,
	userInfo: state => state.user.userInfo,
	serviceId: state => state.twitter.serviceId,
	keywordLanguages: state => state.seo.languageList,
	warningType: state => state.googleAds.warningType,
	operatList: state => state.googleAds.operatList,
	fbmessagechat: state => state.inquiry.fbmessagechat,
	checkouboxData: state => state.googleAds.searchDataCheckboxData,
	// menus: state => state.oss.data
	webList: state => state.chat.webList,
	activeWebsite: state => state.chat.activeWebsite,
	activeWebsiteId: state => state.chat.activeWebsiteId,
	wordDialog: state => state.app.wordDialog,
	wordData: state => state.app.wordData,
	finishValue: state => state.googleAds.finishValue,
};
export default getters;
